module.exports = __webpack_public_path__ + "static/media/50.3a74a800.png";